import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';

import { Box, CssBaseline, Paper } from '@mui/material';

import GlobalStyle from '../components/GlobalStyle';

import { checkSubdomain } from '../apis/subdomainApi';
import { useAuthStore } from '../stores';

interface AuthType {
  children?: React.ReactNode;
}

const Root = styled.div`
  max-width: 520px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(9)};
  }
`;

const Auth: React.FC<AuthType> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  const signOutLocal = useAuthStore.use.signOutLocal();

  useEffect(() => {
    signOutLocal();
    checkSubdomain().then(() => setIsInitialized(true));
  }, []);

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      {isInitialized && (
        <>
          <Wrapper>
            {children}
            <Outlet />
          </Wrapper>
          <Box mt={5}>
            <img src="/static/img/powered-skimmer-2x-dark.png" alt="Skimmer Logo" width={120} />
          </Box>
        </>
      )}
    </Root>
  );
};

export default Auth;
